
import './index.scss';
import CheckpointMasterNotFoundSvgComponent from '../../assets/svg-components/not-found/checkpoint-master';

export default function CheckpointAssignedTaskNotfound() {
  return (
    <>
      <div className="new-not-found-wrap">
        <div className="new-not-found-wrap__details">
          {/* <img
            src="/images/page-not-found/checkpoint-master.svg"
            className="not-found-image img-fluid not-found-image-checkpoint-master"
          /> */}
          <div className='not-found-image not-found-image-checkpoint-master'>
            <CheckpointMasterNotFoundSvgComponent />
          </div>
          <p className="no-data-found-text">Your organisation currently has no checkpoints configured. Please get in touch with the Lexcare administrator to have checkpoints mapped.</p>
        </div>
      </div>
    </>
  );
}
